/** App Store listing — numeric id is the live Peak Performance IQ app (id-only URL; slugs 404). */
export function appStoreUrl(): string {
  const fromEnv = (import.meta as ImportMeta & { env?: Record<string, string> }).env?.VITE_APP_STORE_URL?.trim();
  if (fromEnv) return fromEnv;
  const appId =
    (import.meta as ImportMeta & { env?: Record<string, string> }).env?.VITE_APPLE_APP_STORE_ID?.trim() ||
    '6785338720';
  return `https://apps.apple.com/us/app/id${appId}`;
}

const SESSION_KEY = 'ppiq_session';
const REF_KEY = 'ppiq_ref';

export function getOrCreateAnalyticsSession(): string {
  try {
    let s = localStorage.getItem(SESSION_KEY);
    if (!s) {
      s = `web_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(SESSION_KEY, s);
    }
    return s;
  } catch {
    return `web_${Date.now().toString(36)}`;
  }
}

export function rememberRefCode(code: string) {
  try {
    localStorage.setItem(REF_KEY, code.trim().toUpperCase());
  } catch {
    /* ignore */
  }
}

export function readRefCode(): string | null {
  try {
    return localStorage.getItem(REF_KEY);
  } catch {
    return null;
  }
}

/** Fire-and-forget visit beacon for influencer links. */
export async function trackRefVisit(code: string, path: 'landing' | 'signup' | 'other' = 'landing') {
  const sessionKey = getOrCreateAnalyticsSession();
  rememberRefCode(code);
  try {
    const res = await fetch('/api/analytics/ref-visit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-PPIQ-Session': sessionKey },
      body: JSON.stringify({ code, path, sessionKey }),
    });
    if (res.ok) {
      const j = (await res.json()) as { sessionKey?: string };
      if (j.sessionKey) localStorage.setItem(SESSION_KEY, j.sessionKey);
    }
  } catch {
    /* ignore */
  }
}
